/*
 * @Author: jianfanfan 1217572833@qq.com
 * @Date: 2024-07-05 18:12:58
 * @LastEditors: jianfanfan 1217572833@qq.com
 * @LastEditTime: 2024-07-06 09:29:58
 * @FilePath: \buypos-pc\src\components\verifition\utils\axios.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'

axios.defaults.baseURL = "https://captchaapi.ctaiot.com/api"

const service = axios.create({
    timeout: 40000,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
    },
})
service.interceptors.request.use(
    config => {
        return config
    },
    error => {
        Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data
        return res
    },
    error => {
    }
)
export default service



// WEBPACK FOOTER //
// ./src/components/verifition/utils/axios.js